import styled from "styled-components";

export const Container = styled.footer`
    display: flex;
    justify-content: ${({ justify }) => justify};
	gap: 10px;
`;